import React from "react";
import { styled, Box } from "@mui/material";
import { convertPxToRem } from "@treez-inc/component-library";

interface PageWrapperProps {
  /** React node that becomes the content within the page wrapper */
  children: React.ReactNode;
}

const StyledPageWrapper = styled(Box)(({ theme }) => ({
  margin: convertPxToRem(20),

  [theme.breakpoints.up("sm")]: {
    margin: convertPxToRem(24),
  },
  [theme.breakpoints.up("md")]: {
    margin: convertPxToRem(32),
  },
  [theme.breakpoints.up("lg")]: {
    margin: convertPxToRem(40),
  },
}));

const PageWrapper = ({ children }: PageWrapperProps) => (
  <StyledPageWrapper data-testid="page-wrapper">{children}</StyledPageWrapper>
);

export default PageWrapper;
